import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold" }, "Add Branch", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-close icon-size" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "h-100 d-flex flex-column mb-3 mt-2" }
const _hoisted_7 = { class: "d-flex justify-content-between w-70" }
const _hoisted_8 = { class: "form-group me-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "agency-branch" }, [
  /*#__PURE__*/_createTextVNode(" Agency Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Branch", -1 /* HOISTED */)
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date" }, [
  /*#__PURE__*/_createTextVNode(" Effective Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "input-group date datepickerInput" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_17 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_18 = { class: "form-group w-70" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "comment" }, " Comments", -1 /* HOISTED */)
const _hoisted_20 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        type: "button",
        class: "btn table-btn px-2 btn-outline-info",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAgencyBranch) = $event)),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.selectedAgencyBranch.$touch && _ctx.v$.selectedAgencyBranch.$touch(...args)))
          }, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencyBranches, (location) => {
              return (_openBlock(), _createElementBlock("option", {
                value: location.id
              }, _toDisplayString(location.name), 9 /* TEXT, PROPS */, _hoisted_11))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, _ctx.selectedAgencyBranch]
          ]),
          (_ctx.v$.selectedAgencyBranch.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Agency Branch is required."))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "effectiveDate",
                  class: "form-control rounded-0 border-end-0",
                  placeholder: "MM/DD/YYYY",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.effectiveDate) = $event)),
                  onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.effectiveDate.$touch && _ctx.v$.effectiveDate.$touch(...args)))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelText, _ctx.effectiveDate]
                ]),
                _hoisted_16
              ]),
              (_ctx.v$.effectiveDate.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Effective Date is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["getDate"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _withDirectives(_createElementVNode("textarea", {
          maxlength: "2000",
          class: "form-control",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.comments) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.comments]
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-md me-2",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleAddBranch && _ctx.handleAddBranch(...args)))
        }, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_23))
            : (_openBlock(), _createElementBlock("span", _hoisted_24, "Save"))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-primary btn-md",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
        }, "Cancel")
      ])
    ])
  ]))
}